/**
 * @module account ui
 */
import { createReducer } from '@reduxjs/toolkit';
import { uiActions } from '~/behaviors/actions/ui.actions';
import { metaActions } from '~/behaviors/actions/meta.actions';
import { accountActions } from '~/behaviors/actions/account.actions';
import { convert } from '~/tools/convert';
import { errors } from '~/tools/errors';

const defaultState = {
  isAuthenticating: false,
  isRestoring: false,
  isLoggingOut: false,
  isLockedOut: false,
  forgotPasswordEmail: '',
  error: null,
};

const reset = () => defaultState;

const merge = (updates) => (state) => ({
  ...state,
  ...updates,
});

const changeUI = (state, action) => {
  const updates = action?.payload || {};
  // @ts-expect-error TS(2345): Argument of type 'string[]' is not assignable to p... Remove this comment to see the full error message
  const sanitizedProps = convert.pick(updates, Object.keys(defaultState));

  return {
    ...state,
    ...sanitizedProps,
  };
};

const accountUI = createReducer(defaultState, (builder) => {
  builder.addCase(metaActions.reset, reset);
  builder.addCase(accountActions.switchCompany.pending, reset);
  builder.addCase(uiActions.changeAccountUI, changeUI);
  builder.addCase(accountActions.logout.pending, merge({ isLoggingOut: true }));

  builder.addCase(accountActions.logout.fulfilled, (state, action) => {
    state.isLoggingOut = false;

    if (action.payload.logoutError) {
      state.error = {
        name: action.payload.logoutError.name,
        message: action.payload.logoutError.message,
      };
    }
  });

  builder.addCase(accountActions.checkSSO.pending, merge({ isAuthenticating: true }));
  builder.addCase(accountActions.loginWithSSO.pending, merge({ isAuthenticating: true }));
  builder.addCase(accountActions.loginWithPassword.pending, merge({ isAuthenticating: true }));
  builder.addCase(accountActions.loginWithPassword.rejected, merge({ isAuthenticating: false }));
  builder.addCase(accountActions.init.fulfilled, merge({ isAuthenticating: false, isRestoring: false }));

  builder.addCase(accountActions.init.rejected, (state, action) => {
    state.isAuthenticating = false;
    state.isRestoring = false;
    state.error = {
      name: action.error.name,
      message: action.error.message,
    };
  });

  builder.addCase(accountActions.restoreAccount.pending, merge({ isRestoring: true }));

  builder.addCase(accountActions.restoreAccount.rejected, (state, action) => {
    state.isRestoring = false;
    state.error = {
      name: action.error.name,
      message: action.error.message,
    };
  });

  builder.addCase(accountActions.checkSSO.fulfilled, merge({ isAuthenticating: false }));

  builder.addCase(accountActions.checkSSO.rejected, (state, action) => {
    state.isAuthenticating = false;
    state.error = {
      name: action.error.name,
      message: action.error.message,
    };
  });

  builder.addCase(accountActions.getActivationDetails.rejected, (state, _action) => {
    state.error = {
      name: errors.types.activation,
    };
  });
});

export default accountUI;
